import React, { useEffect, useRef, useState } from 'react'
import { SearchBar } from 'antd-mobile'
import general from '../../general'
import Dialog from '../../lib/Dialog'
import CommunityItem from '../game/detail/Community/comments/CommunityItem'
import { useLocalStorageState, useScroll } from 'ahooks'
import { Link } from 'react-router-dom'
import $ from 'jquery'

export default function CommunitySearch(props) {

  const { circles_type, topic_id } = props.query
  const ref = useRef()
  const [list, setList] = useState([])
  const [page, setPage] = useState(1)
  const [more, setMore] = useState(false)
  const [init, setInit] = useState(false)
  const [loading, setLoading] = useState(false)
  const [search_info, setSearchInfo] = useState(null)
  const [searchHistory, setSearchHistory] = useLocalStorageState('community_search_history', [])
  const [searching, setSearching] = useState(false)
  const [currentVideoIndex, setCurrentVideoIndex] = useState(null);
  const videoRefs = useRef([]); // Player 实例数组（用于全局暂停）

  useEffect(() => {
    if (search_info) {
      handleSearch({ page: 1 })
    }
  }, [search_info]);

  const handleSearch = (params) => {
    if (loading) {
      return
    }
    setLoading(true)
    let tmp = {}
    if (params.page) {
      tmp.pagination = {
        page: params.page,
        count: 20
      }
    }
    Dialog.loading()
    // 搜索逻辑
    general.axios.post('/getCommunityList', {
      search_info,
      circles_type,
      topic_id,
      pagination: { page: tmp.pagination.page, count: 20 }
    })
      .finally(() => {
        Dialog.close()
        setLoading(false)
        setInit(true)
      })
      .then(res => {
        const { status, data: { paginated, community_list } } = res.data
        if (status.succeed) {
          setList(params.page && params.page > 1 ? [...list, ...community_list] : community_list)
          params.page && setPage(params.page)
          setMore(paginated.more && community_list.length > 0)
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  const scroll = useScroll()
  useEffect(() => {
    if (props.active && init) {
      if (scroll.top < -80) {
        handleSearch({ page: 1 })
      }
      if (scroll.top + window.innerHeight + 20 > $(document).height() && more) {
        handleSearch({ page: page + 1 })
      }
    }

  }, [scroll, props.active, init])

  useEffect(() => {
    if (props.active) {
      props.setTitle(<div>
        <SearchBar
          placeholder='搜索帖子'
          ref={ref}
          searchIcon={<img style={{ position: 'relative', top: '-1.5px' }} src='/resources/user/ss.png' alt='' height={14} />}
          onlyShowClearWhenFocused={true}
          style={{
            '--height': '32px',
            '--padding-left': '15px',
            overflow: 'hidden',
            flex: '1',
            borderRadius: '16px',
          }}
        ></SearchBar>
      </div>)
      props.setOperate(<div style={{ color: 'var(--MainColor)', fontSize: 13 }} onClick={() => {
        setSearching(true)
        setSearchInfo(ref.current.nativeElement.value.trim())
        const searchText = ref.current.nativeElement.value.trim()
        if (searchHistory.indexOf(searchText) === -1 && searchText !== '') {
          setSearchHistory([searchText, ...searchHistory])
        }
      }}>搜索</div>)
    }
  }, [props.active])

  // 播放指定视频的函数（不变）
  const playVideo = (index) => {
    const currentPlayer = videoRefs.current[index];
    if (currentPlayer) {
      // 暂停所有其他 Player
      videoRefs.current.forEach((player, i) => {
        if (player && i !== index) {
          player.pause();
          player.seek(0); // 可选：重置到开头
        }
      });
      // 播放当前 Player
      currentPlayer.play()
      setCurrentVideoIndex(index);
    }
  };

  // 为每个 Player 创建 ref 的回调函数（简化）
  const setVideoRef = (index) => (element) => {
    if (element && !videoRefs.current[index]) {
      videoRefs.current[index] = element;
    }
  };

  return (
    <div className='community-search-page'>
      {list.length > 0 && <div style={{ paddingTop: '15px' }}>
        {list.map((item, index) => (
          <Link key={item.id + index} to={'/communityDetail?id=' + (parseInt(item.recover) === 2 ? item.community_id : item.id) + '&tagid=' + item.tagid + '&circles_type=' + item.circles_type + '&topic_id=' + item.maiyou_gameid}>
            <CommunityItem
              key={index}
              item={item}
              index={index}
              currentVideoIndex={currentVideoIndex}
              onPlayVideo={playVideo}
              setVideoRef={setVideoRef}
              isfootMark={false}></CommunityItem>
          </Link>
        ))}
      </div>}
      {list.length > 0 && !more && init && <div className="view-end">别撩啦！已经到底啦~</div>}
      {init && list.length == 0 && <div className="empty"><img src="/resources/empty.png" alt="" />暂无数据</div>}
      {!searching && <div style={{ padding: '15px 0 15px 15px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingRight: 15 }}>
          <div style={{ fontSize: 17, color: '#282828', fontWeight: 500 }}>搜索历史</div>
          <div onClick={() => setSearchHistory([])}><img src="resources/251009/history_delete.png" alt="" height={17} /></div>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {searchHistory.map((item, index) => (
            <div
              onClick={() => {
                setSearching(true)
                setSearchInfo(item)
                ref.current.nativeElement.value = item
              }}
              key={index}
              style={{ marginTop: 10, marginRight: 10, backgroundColor: '#F5F5F5', fontSize: 13, color: '#666', padding: '2px 10px', borderRadius: 12 }}>{item}</div>
          ))}
        </div>
      </div>}
    </div>
  )
}
